import { Grid } from '@mui/material'
import { FormField } from 'global/components/Form'

export default function FormNovaCompensacaoFeriado() {
    return (
        <Grid container spacing={2} columns={8}>
            <FormField name="empresaId" sx={{ display: 'none' }} />
            <FormField name="funcionarioId" sx={{ display: 'none' }} />
            <Grid item xs={4}>
                <FormField
                    label="Data da compensação"
                    name={'dataCompensacao'}
                    type="date"
                    disabled
                />
            </Grid>
            <Grid item xs={4}>
                <FormField
                    label="Data do feriado"
                    name={'dataFeriado'}
                    type="date"
                />
            </Grid>
        </Grid>
    )
}
